import React from "react";
import "./reportBox.css";
import Button from "../ButtonComponent/Button";
import DownArrow from "../../assets/images/dropdownArrow.svg";
import CalenderIcon from "../../assets/images/calenderIcon.svg";
import DatePicker from "react-multi-date-picker";
import Contents from "../../constants/contentFile.json";
import DropDownItem from "../DropDownComponent/DropDown";
import ReportCategory from "../ReportCategoryComponent/ReportCategory";
import ReportTimeBox from "../ReportTimeBoxComponent/ReportTimeBox";
import { Col, Row } from "react-bootstrap";
import { useState } from "react";
import ReportContent from "../../constants/contentFile.json";
import { Spinner } from "react-bootstrap";

const ReportBox = ({
  showDropdownList,
  setShowDropdownList,
  filterCriteria,
  setFilterCriteria,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  submitReport,
  criteriaRequired,
  spinnerStatus,
  fromTime,
  setFromTime,
  toTime,
  setToTime,
  visitorType,
  visitorTypeList,
  setVisitorType,
  onHandleSubmit, // when select extended stay and submit
}) => {
  const reportList = ReportContent.report;
  const [validDates, setValidDates] = useState(true);
  const [validTimeFrame, setValidTimeFrame] = useState(true);
  const reportConstants = Contents.reportComponent;
  const criteriaList = Contents.report;
  // const filterList = criteriaList?.map((item) => {
  //   return (
  //     <div
  //       className="listDataFilterContainerReportBox"
  //       key={""}
  //       onClick={() => {
  //         setFilterCriteria(item.criteriaType);
  //         setShowDropdownList(false);
  //       }}
  //     >
  //       <span className="criteriaTextFilter">{item.criteriaType}</span>
  //     </div>
  //   );
  // });

  return (
    <div
      className={
        filterCriteria.id === "visitor"
          ? "outer-container-report-box bigger-box"
          : "outer-container-report-box"
      }
    >
      <Col lg={12}>
        <Row>
          <Col lg={12} className="reportText">
            {reportConstants.report}
          </Col>
        </Row>
        <Col lg={12}>
          <Row>
            <Col lg={12}>
              <DropDownItem
                selectedItem={filterCriteria}
                setSelectedItem={setFilterCriteria}
                list={reportList}
                categoryRequired={criteriaRequired}
              />
            </Col>
          </Row>
          {filterCriteria.id === "visitor" && (
            <Row>
              <div className="category-selector">
                <ReportCategory
                  selectedItem={visitorType}
                  setSelectedItem={setVisitorType}
                  list={visitorTypeList}
                />
              </div>
            </Row>
          )}

          <div
            className={
              filterCriteria.id === "extendedStay" ? "display-none" : ""
            }
          >
            <Row className="mt-3">
              <Col lg={6}>
                <DatePicker
                  showOtherDays
                  className="date-picker"
                  format="YYYY-MM-DD"
                  render={(value, openCalendar) => {
                    return (
                      <div onClick={openCalendar}>
                        <div
                          className={
                            validDates
                              ? "fromDateContainerReportBox"
                              : "fromDateContainerReportBox not-valid"
                          }
                        >
                          <div className="fromToContainerReportBox">
                            <span className="selectTextReportBox">
                              {setFromDate(value)}
                              {fromDate === "" ? "From Date" : fromDate}
                            </span>
                          </div>
                          <div className="calenderReportBox">
                            <img src={CalenderIcon} />
                          </div>
                        </div>
                      </div>
                    );
                  }}
                />
              </Col>
              <Col lg={6}>
                <DatePicker
                  showOtherDays
                  format="YYYY-MM-DD"
                  render={(value, openCalendar) => {
                    return (
                      <div onClick={openCalendar}>
                        <div
                          className={
                            validDates
                              ? "fromDateContainerReportBox"
                              : "fromDateContainerReportBox not-valid"
                          }
                        >
                          <div className="fromToContainerReportBox">
                            <span className="selectTextReportBox">
                              {setToDate(value)}
                              {toDate === "" ? "To Date" : toDate}
                            </span>
                          </div>
                          <div className="calenderReportBox">
                            <img src={CalenderIcon} />
                          </div>
                        </div>
                      </div>
                    );
                  }}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col lg={6}>
                <ReportTimeBox
                  clname={validTimeFrame ? null : "not-valid"}
                  selectedItem={fromTime}
                  setSelectedItem={setFromTime}
                />
              </Col>
              <Col lg={6}>
                <ReportTimeBox
                  clname={validTimeFrame ? null : "not-valid"}
                  selectedItem={toTime}
                  setSelectedItem={setToTime}
                />
              </Col>

              <Col lg={12} className="button-container-report-box mt-3">
                <Button
                  text={spinnerStatus ? <Spinner size="sm" /> : "SUBMIT"}
                  onClick={() => {
                    if (
                      fromDate != "" &&
                      toDate != "" &&
                      fromDate <= toDate &&
                      Number(fromTime?.id?.slice(0, 2)) <=
                        Number(toTime?.id?.slice(0, 2))
                    ) {
                      setValidTimeFrame(true);
                      setValidDates(true);
                      submitReport();
                    } else if (
                      fromDate != "" &&
                      toDate != "" &&
                      fromDate < toDate
                    ) {
                      setValidTimeFrame(true);
                      setValidDates(true);
                      submitReport();
                    } else if (
                      fromDate == "" ||
                      toDate == "" ||
                      fromDate > toDate
                    ) {
                      setValidDates(false);
                      setValidTimeFrame(true);
                    } else {
                      setValidDates(true);
                      setValidTimeFrame(false);
                    }
                  }}
                />
              </Col>
            </Row>
          </div>
          <Row
            className={
              filterCriteria.id === "extendedStay"
                ? "show-button"
                : "display-none"
            }
          >
            <Col lg={12} className="button-container-report-box mt-3">
              <Button
                text={spinnerStatus ? <Spinner size="sm" /> : "SUBMIT"}
                onClick={onHandleSubmit}
              />
            </Col>
          </Row>
        </Col>
      </Col>
    </div>
  );
};

export default ReportBox;
